import axios from './axios';

// api endpoints
const endpoints = {
  getNotifications: '/api/license/notification_history'
};

/**
 * Get the notification history list (paginated, filter, sort)
 *
 * @param accessToken {string}    user access token
 * @param page {number}           page number (default 1)
 * @param pageSize {number}       page size (default 20)
 * @param sort {string}           sort string, e.g. 'created_at:desc'
 * @param filter {object}         filter object, e.g. { 'status:eq': 'fail' }
 * @return {Promise<AxiosResponse<T>>}
 */
const getNotifications = async (accessToken, page = 1, pageSize = 20, sort, filter) => {
  let result = undefined;

  const headers = {
    Authorization: `google-token ${accessToken}`
  };

  const params = {
    page,
    page_size: pageSize
  };

  if (sort) {
    params.sort = sort;
  }
  if (filter) {
    Object.keys(filter).forEach(key => {
      params[`filter[${key}]`] = filter[key];
    });
  }

  try {
    result = await axios.get(endpoints.getNotifications, { headers, params });
  } catch (error) {
    console.log(error);
    result = error;
  }

  return result;
};

export default {
  getNotifications
};
